import { CLEAN_FORM, ERROR_LIST, RECEIVE_LIST, REQUEST_LIST, SET_ENTITY, SET_ERROR, SET_MASK, SET_ORDER, SET_PAGE, SET_PAGE_SIZE, SET_SELECTED_ROW, SET_STATE_FORM, UPDATE_FIELD_ENTITY, UPDATE_FIELD_FILTER, UPDATE_TABLE_COLUMN } from './types';

const initialState = {
    formState: 'search',
    loading: false,
    entity: {
        rolId: '',
        nombre: '',
    },
    errors: {
        nombre: '',
    },
    filters: {
        aplicacionClienteId: '',
    },
    store: {
        loading: false,
        pageSize: 50,
        start: 0,
        total: 0,
        data: [],
        selected: [],
        source: null,
    },
    table: {
        order: 'asc',
        orderBy: '',
        columns: [{ dataKey: 'nombre', label: 'Rol', width: 600 }],
    },
};

export const rolesReducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case CLEAN_FORM:
            return {
                ...state,
                entity: initialState.entity,
                errors: initialState.errors,
            };

        case ERROR_LIST:
            return {
                ...state,
                store: {
                    ...state.store,
                    loading: false,
                    start: 0,
                    total: 0,
                    data: [],
                    source: null,
                },
            };
        case RECEIVE_LIST:
            return {
                ...state,
                store: {
                    ...state.store,
                    loading: false,
                    total: action.total,
                    data: action.payload,
                    source: null,
                },
            };
        case REQUEST_LIST:
            return {
                ...state,
                store: {
                    ...state.store,
                    loading: true,
                    source: action.source,
                },
            };
        case SET_ENTITY:
            return {
                ...state,
                entity: {
                    ...state.entity,
                    rolId: action.payload.rolId,
                    nombre: action.payload.nombre,
                },
            };
        case SET_ERROR:
            return {
                ...state,
                errors: {
                    ...state.errors,
                    [action.key]: action.error,
                },
            };
        case SET_MASK:
            return {
                ...state,
                loading: action.loading,
            };
        case SET_ORDER:
            return {
                ...state,
                table: {
                    ...state.table,
                    order: action.order,
                    orderBy: action.orderBy,
                },
            };
        case SET_PAGE:
            return {
                ...state,
                store: {
                    ...state.store,
                    start: state.store.pageSize * action.page,
                },
            };
        case SET_PAGE_SIZE:
            return {
                ...state,
                store: {
                    ...state.store,
                    pageSize: action.pageSize,
                },
            };
        case SET_SELECTED_ROW:
            return {
                ...state,
                store: {
                    ...state.store,
                    selected: action.selected,
                },
            };
        case SET_STATE_FORM:
            return {
                ...state,
                formState: action.formState,
            };
        case UPDATE_FIELD_ENTITY:
            return {
                ...state,
                entity: {
                    ...state.entity,
                    [action.key]: action.value,
                },
            };
        case UPDATE_FIELD_FILTER:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.key]: action.value,
                },
            };
        case UPDATE_TABLE_COLUMN:
            return {
                ...state,
                table: {
                    ...state.table,
                    columns: action.columns,
                },
            };
        default:
            return state;
    }
};
